import { OpenDay } from 'apollo/types';
import moment from 'moment-timezone';

export const addDays = (date: Date, days: number): Date => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

const isDayInArray = (calendarDate: moment.Moment, openDays: OpenDay[]): boolean => {
  const startOfDayValue = calendarDate.startOf('day');

  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  return (
    openDays
      ?.map((openDay) => {
        const momentOpenDay = moment.tz(openDay.day.slice(0, -1), timeZone);

        const startOfOpenDay = moment.tz(momentOpenDay, timeZone).startOf('day');

        const endOfOpenDay = moment.tz(momentOpenDay, timeZone).endOf('day');

        return startOfDayValue.isBetween(startOfOpenDay, endOfOpenDay, undefined, '[]');
      })
      .filter((day) => day === true).length === 0
  );
};

export default isDayInArray;
